// Dynamic Diesels — mega-menu hover behavior (handoff §5.3, §7).
// Open on trigger mouseenter, stay open over the panel, close 250ms
// after the pointer has left both. Each panel is anchored under its own
// trigger so the pointer can travel straight down into it.

(function () {
  'use strict';

  const CLOSE_DELAY_MS = 250;
  const NAV_GUTTER = 24;
  // Panel inner padding (22) + link padding (12) − trigger padding (10):
  // lines the first mega-link's text up under the trigger's label.
  const TEXT_ALIGN_OFFSET = 24;
  let closeTimer = null;

  function init() {
    const triggers = document.querySelectorAll('.dd-nav__link[data-menu]');
    if (!triggers.length) return;

    triggers.forEach((trigger) => {
      const key = trigger.getAttribute('data-menu');
      const panel = document.querySelector('.dd-mega-panel[data-menu-panel="' + key + '"]');
      if (!panel) return;

      trigger.addEventListener('mouseenter', () => openPair(trigger, panel));
      trigger.addEventListener('focus', () => openPair(trigger, panel));
      trigger.addEventListener('mouseleave', scheduleClose);

      panel.addEventListener('mouseenter', cancelClose);
      panel.addEventListener('mouseleave', scheduleClose);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll();
    });

    window.addEventListener('resize', closeAll);
  }

  function openPair(trigger, panel) {
    cancelClose();
    closeAll();
    trigger.classList.add('is-active');
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    positionPanel(trigger, panel);
  }

  // Must run while the panel is open — a display:none panel has no width.
  function positionPanel(trigger, panel) {
    const nav = panel.offsetParent;
    if (!nav) return;

    const navRect = nav.getBoundingClientRect();
    const triggerRect = trigger.getBoundingClientRect();
    const maxLeft = navRect.width - panel.offsetWidth - NAV_GUTTER;
    let left = triggerRect.left - navRect.left - TEXT_ALIGN_OFFSET;

    if (left > maxLeft) left = maxLeft;
    if (left < NAV_GUTTER) left = NAV_GUTTER;

    panel.style.left = left + 'px';
    panel.style.transform = 'none';
  }

  function scheduleClose() {
    cancelClose();
    closeTimer = setTimeout(closeAll, CLOSE_DELAY_MS);
  }

  function cancelClose() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  function closeAll() {
    document.querySelectorAll('.dd-nav__link.is-active').forEach((l) => l.classList.remove('is-active'));
    document.querySelectorAll('.dd-mega-panel.is-open').forEach((p) => {
      p.classList.remove('is-open');
      p.setAttribute('aria-hidden', 'true');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
